// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__+jZHY","card":"Card_card__-SwHU","titleWrapper":"Card_titleWrapper__GdvUU","banner":"Card_banner__1Y9cv","chip":"Card_chip__agKFm"};